import "../pages/Errorpage.css";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div className="error-page">
      <div className="error-content">
        <h1>404</h1>
        <h2>Stránka nenalezena</h2>
        <p>Je nám líto, ale požadovaná stránka nebyla nalezena.</p>
        <Link to="/" className="error-button">
          Zpět na hlavní stránku
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
